import React from 'react';

const SkeletonProduct = () => {
  return (
    <div className="animate-pulse px-4 pt-20 max-w-7xl mx-auto">
      {/* Main Container */}
      <div className="flex flex-col sm:flex-row gap-8 lg:gap-16">
        {/* Left Skeleton: Image Carousel + Wishlist/Share */}
        <div className="w-full sm:w-1/2 lg:w-[45%] flex flex-col gap-4 relative">
          {/* Main Image */}
          {/* Main Image */}
          <div className="flex-1 relative">
            <div className="w-full h-[500px] sm:h-[600px] bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl shadow-lg overflow-hidden relative">
              <div className="absolute inset-0 bg-gray-200/20"></div>

              {/* Wishlist Button - Top Left */}
              <div className="absolute top-4 left-4">
                <div className="w-10 h-10 bg-gradient-to-r from-gray-200 to-gray-100 rounded-full shadow-md"></div>
              </div>

              {/* Share Button - Top Right */}
              <div className="absolute top-4 right-4">
                <div className="w-10 h-10 bg-gradient-to-r from-gray-200 to-gray-100 rounded-full shadow-md"></div>
              </div>
            </div>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-2">
            {[...Array(4)].map((_, i) => (
              <div
                key={i}
                className="w-3 h-3 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full"
              ></div>
            ))}
          </div>
        </div>

        {/* Right Skeleton: Text Info */}
        <div className="flex-1 space-y-6 pt-2">
          {/* Brand */}
          <div className="h-5 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-1/4"></div>

          {/* Product Title */}
          <div className="h-9 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-4/5"></div>

          {/* Rating Stars */}
          <div className="flex gap-1 items-center">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="w-5 h-5 bg-gradient-to-r from-gray-300 to-gray-200 rounded-sm"
              ></div>
            ))}
            <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-16 ml-2"></div>
          </div>

          {/* Price */}
          <div className="h-12 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-1/3"></div>

          {/* Divider */}
          <div className="h-px bg-gray-200 w-full my-4"></div>

          {/* Color Options */}
          <div>
            <div className="h-5 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-24 mb-3"></div>
            <div className="flex gap-3">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="w-8 h-8 bg-gray-300 rounded-full shadow-sm"></div>
              ))}
            </div>
          </div>

          {/* Size Selector */}
          <div>
            <div className="h-5 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-20 mb-3"></div>
            <div className="flex gap-2">
              {['XS', 'S', 'M', 'L', 'XL'].map((_, i) => (
                <div
                  key={i}
                  className="w-12 h-10 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md"
                ></div>
              ))}
            </div>
          </div>

          {/* Add to Cart Button */}
          <div className="h-14 bg-gradient-to-r from-gray-300 to-gray-200 rounded-xl w-2/3 mt-6"></div>

          {/* Shipping Info */}
          <div className="flex items-center gap-2 mt-4">
            <div className="w-6 h-6 bg-gradient-to-r from-gray-200 to-gray-100 rounded-full"></div>
            <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-3/5"></div>
          </div>
        </div>
      </div>

      {/* Description / Reviews Toggle Skeleton */}
      <div className="mt-16 border-t border-gray-100 pt-8">
        <div className="flex gap-8 mb-6">
          <div className="h-6 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-24"></div>
          <div className="h-6 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-24"></div>
          <div className="h-6 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-24"></div>
        </div>
        <div className="space-y-3">
          <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-full"></div>
          <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-5/6"></div>
          <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-4/5"></div>
          <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-2/3"></div>
        </div>
      </div>

      {/* Related Products */}
      <div className="mt-16 pb-12">
        <div className="h-8 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-1/5 mb-6"></div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="space-y-3">
              <div className="aspect-square bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl shadow-md overflow-hidden"></div>
              <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-2/3"></div>
              <div className="h-5 bg-gradient-to-r from-gray-200 to-gray-100 rounded-md w-1/2"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonProduct;
